import { render, staticRenderFns } from "./ValveUpInstructions.vue?vue&type=template&id=477b462f&"
import script from "./ValveUpInstructions.vue?vue&type=script&lang=js&"
export * from "./ValveUpInstructions.vue?vue&type=script&lang=js&"
import style0 from "./ValveUpInstructions.vue?vue&type=style&index=0&id=477b462f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports